import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'
import _imports_1 from '@/assets/img/management/search.svg'
import _imports_2 from '@/assets/img/management/edit.svg'


const _hoisted_1 = { class: "genericPadding hasHeader hasFooter bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_5 = { class: "d-flex align-items-center flex-column" }
const _hoisted_6 = { class: "form-group squareInputContainer withLabel w-100 me-2" }
const _hoisted_7 = { class: "form-group squareInputContainer withLabel" }
const _hoisted_8 = { class: "d-flex align-items-center  flex-column" }
const _hoisted_9 = { class: "form-group squareInputContainer withLabel w-100 me-2" }
const _hoisted_10 = { class: "form-group squareInputContainer withLabel" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "form-group squareInputContainer withLabel w-100 me-1" }
const _hoisted_13 = { class: "form-group squareInputContainer withLabel w-100 ms-1" }
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 0,
  src: _imports_1,
  class: "me-2"
}
const _hoisted_17 = {
  key: 2,
  src: _imports_2,
  class: "me-2"
}
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { class: "footerButtonContainer" }
const _hoisted_20 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _directive_date = _resolveDirective("date")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode(_component_localized_text, {
        class: "fs_12 greyBlue",
        localizedKey: "app_modificaevento",
        text: "Modifica evento"
      }),
      _hoisted_4
    ]),
    _createVNode(_component_localized_text, {
      class: "fs_12 greyBlue d-block mb-2",
      localizedKey: "app_inizioevento",
      text: "Inizio evento"
    }),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_data",
            text: "Data",
            class: "fs_12 grey"
          })
        ]),
        _withDirectives(_createVNode("input", {
          type: "date",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.editEventInfo.dateFrom = $event)),
          class: "genericInput squareInput dateInput"
        }, null, 512), [
          [_vModelText, _ctx.editEventInfo.dateFrom],
          [_directive_date]
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_ora",
            text: "Ora",
            class: "fs_12 grey"
          })
        ]),
        _withDirectives(_createVNode("input", {
          type: "time",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.timeFrom = $event)),
          class: "genericInput squareInput dateInput"
        }, null, 512), [
          [_vModelText, _ctx.timeFrom]
        ])
      ])
    ]),
    _createVNode(_component_localized_text, {
      class: "fs_12 greyBlue d-block mt-2 mb-2",
      localizedKey: "app_fineevento",
      text: "Fine evento"
    }),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_data",
            text: "Data",
            class: "fs_12 grey"
          })
        ]),
        _withDirectives(_createVNode("input", {
          type: "date",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.editEventInfo.dateTo = $event)),
          class: "genericInput squareInput dateInput"
        }, null, 512), [
          [_vModelText, _ctx.editEventInfo.dateTo],
          [_directive_date]
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_ora",
            text: "Ora",
            class: "fs_12 grey"
          })
        ]),
        _withDirectives(_createVNode("input", {
          type: "time",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.timeTo = $event)),
          class: "genericInput squareInput dateInput"
        }, null, 512), [
          [_vModelText, _ctx.timeTo]
        ])
      ])
    ]),
    _createVNode(_component_localized_text, {
      class: "fs_12 greyBlue d-block mt-2 mb-2",
      localizedKey: "app_oraridiaperturatestuale",
      text: "Orari di apertura (testo)"
    }),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        _createVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_dalle",
            text: "Dalle",
            class: "fs_12 grey"
          })
        ]),
        _withDirectives(_createVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.editEventInfo.openFrom = $event)),
          class: "genericInput squareInput"
        }, null, 512), [
          [_vModelText, _ctx.editEventInfo.openFrom],
          [_directive_date]
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_alle",
            text: "Alle",
            class: "fs_12 grey"
          })
        ]),
        _withDirectives(_createVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.editEventInfo.openTo = $event)),
          class: "genericInput squareInput"
        }, null, 512), [
          [_vModelText, _ctx.editEventInfo.openTo]
        ])
      ])
    ]),
    _createVNode(_component_localized_text, {
      class: "fs_12 greyBlue d-block mt-2 mb-2",
      localizedKey: "app_eventoOnline",
      text: "Evento online?"
    }),
    _createVNode("div", _hoisted_14, [
      _createVNode("div", {
        class: ["filterTab w-100 me-1", !_ctx.editEventInfo.isOnlineEvent ? 'active' : ''],
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.editEventInfo.isOnlineEvent = false))
      }, [
        _createVNode(_component_localized_text, {
          class: "fs_12 d-block",
          localizedKey: "app_no",
          text: "No"
        })
      ], 2),
      _createVNode("div", {
        class: ["filterTab w-100 ms-1", _ctx.editEventInfo.isOnlineEvent ? 'active' : ''],
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editEventInfo.isOnlineEvent = true))
      }, [
        _createVNode(_component_localized_text, {
          class: "fs_12 d-block",
          localizedKey: "app_si",
          text: "Si"
        })
      ], 2)
    ]),
    (!_ctx.editEventInfo.isOnlineEvent)
      ? (_openBlock(), _createBlock("div", _hoisted_15, [
          _createVNode(_component_localized_text, {
            class: "fs_12 greyBlue d-block mt-2 mb-2",
            localizedKey: "app_indirizzo",
            text: "Indirizzo"
          }),
          _createVNode("div", {
            class: "mb-3 d-flex align-items-center",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.searchCity()))
          }, [
            (!_ctx.editEventInfo.address.typedAddress)
              ? (_openBlock(), _createBlock("img", _hoisted_16))
              : _createCommentVNode("", true),
            (!_ctx.editEventInfo.address.typedAddress)
              ? (_openBlock(), _createBlock(_component_localized_text, {
                  key: 1,
                  localizedKey: 'app_selezionaunindirizzo',
                  text: 'Seleziona un\'indirizzo'
                }))
              : _createCommentVNode("", true),
            (_ctx.editEventInfo.address.typedAddress)
              ? (_openBlock(), _createBlock("img", _hoisted_17))
              : _createCommentVNode("", true),
            (_ctx.editEventInfo.address.typedAddress)
              ? (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(_ctx.editEventInfo.address.typedAddress), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_19, [
      _createVNode("div", _hoisted_20, [
        _createVNode("button", {
          type: "button",
          class: "genericButton bgWhite w-100 me-1",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_component_localized_text, {
            class: "fs_14 spaceCadet",
            localizedKey: "app_annulla",
            text: "Annulla"
          })
        ]),
        _createVNode("button", {
          type: "button",
          class: "genericButton bgGreyBlue w-100 ms-1",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.save()))
        }, [
          _createVNode(_component_localized_text, {
            class: "fs_14 white",
            localizedKey: "app_conferma",
            text: "Conferma"
          })
        ])
      ])
    ])
  ]))
}